import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { TestimonialRequestAdminAPI } from '../../services/admin/testimonialRequestAdminAPI';
import { TestimonialLinkSubmissionAdminAPI } from '../../services/admin/testimonialLinkSubmissionAdminAPI';
import { BrandVideoAdminAPI } from '../../services/admin/brandVideoAdminAPI';
import { BackgroundMusicAPI } from '../../services/backgroundMusicAPI';
import {VideoDetailsBase} from '../base/video';
import { FontAPI } from '../../services/fontAPI';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';
import { EnvironmentService } from '../../services/environmentService';
import { TranscriptGenerator } from "../../services/transcriptGenerator";

@inject(AuthService, UserMessageService, Router, BackgroundMusicAPI, FontAPI, AccountAdminAPI, EnvironmentService, TranscriptGenerator)
export class VideoDetails extends VideoDetailsBase {
    constructor(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, envService, transcriptGenerator) {
        super(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, "api/admin", TestimonialRequestAdminAPI, TestimonialLinkSubmissionAdminAPI, BrandVideoAdminAPI, envService, true, transcriptGenerator);
        this.fileBase = '';
        this.dashboardlength = 'col-sm-12';
        this.isdashboard = false;
        this.brand_video_aws = false;
        this.email = null;

    }

    activate(params, route) {

        super.activate(params, route);
        if(!params.id && params.account_owner_id) {
            this.account_owner_user_id = params.account_owner_id;
        }

        if(this.id) {
            this.api.getFileList(
                this.id,
                this.authService.getUser().token,
                this.getFileListSuccess.bind(this),
                this.saveLoadError.bind(this));
        }

    }

    reset() {


        this.accountApi.getUserData(
            this.account_owner_user_id,
            this.authService.getUser().token,
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                super.reset();
            },
            this.saveLoadError.bind(this));
    }

    setData(data) {
        super.setData(data);

        this.accountApi.getUserData(
            this.account_owner_user_id,
            this.authService.getUser().token,
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                this.email = userData.user.email;

            },
            this.saveLoadError.bind(this));

        this.capture_override = data.capture_override;

        this.api.getFileList(
            this.id,
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    recreate() {
        if (confirm("Are you sure you want to re-create this video?")) {
            if (this.validate()) {
              if (this.enableSubtitle) {
                if (this.subtitles.caption.length == 0) {
                  this.userMessageService.setUserError(
                    "user",
                    "Subtitles are empty."
                  );
                  return;
                }
                this.subtitles.styles = this.transcriptGenerator.selectedStyle
                ? this.transcriptGenerator.selectedStyle
                : this.transcriptGenerator.styles[0]; //settting default styles
    
              }

      this.saving = true;
      var data = this.getData();
      this.api.recreate(
          data,
          (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
          this.authService.getUser().token,
          this.saveLoadSuccess.bind(this),
          this.saveLoadError.bind(this));

      }
        }
    }
    getFileListSuccess(files, bucket) {
        this.files = files;


        if(this.link_submission)
            this.fileBase = this.apiBase + "/testimonialLinkSubmission/downloadFile/" + this.id;
        else if(this.brand_video) {
            if(bucket){
                this.brand_video_aws = true;
                this.fileBase = "https://"+bucket+".s3.amazonaws.com/";
            }else{
                this.fileBase = this.apiBase + "/brandVideo/downloadFile/" + this.id;
            }
        } else {
            this.fileBase = this.apiBase + "/testimonialRequest/downloadFile/" + this.id;
        }

    }

    uploadCaptureOverride() {
        if (this.captureOverride_files && this.captureOverride_files.length > 0) {
            this.saving = true;
            this.api.saveCaptureOverride(this.id,
                this.captureOverride_files[0],
                this.authService.getUser().token,
                () => {this.overrideCaptureChanged(true)},
                (msg) => { this.userMessageService.setUserError("user", msg)});
        }
    }

    removeCaptureOverride() {
        this.saving = true;
        this.api.removeCaptureOverride(this.id,
            this.authService.getUser().token,
            () => {this.overrideCaptureChanged(false)},
            (msg) => { this.userMessageService.setUserError("user", msg)});
    }

    overrideCaptureChanged(capture_override) {
        this.userMessageService.setUserMessage("user", "Saved!");

        this.saving = false;

        this.capture_override = capture_override;
        this.api.getFileList(
            this.id,
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            (msg) => { this.userMessageService.setUserError("user", msg)});

    }
    onNavigate() {
        this.navPanelClass = '';
      }


    navigateLink(route, replace = false) {
        console.log("route param123",route);
        localStorage.setItem('rout', route);
        if(route.includes("#/user/video/email"))
        {
          if(route.includes("upload"))
          route = route + "?captureType=3" + "?videoUpload=1";
          else
          route = route + "?captureType=3";
          // window.location.href = "Posts?Category=" + sel;
        }
        if(route.includes("#/user/home") || route == "#/user" || route === "#/user/video/request" || route === "#/user/video/caseStudy" || route.includes("#/user/video/email"))
        {
          this.isdashboard = true;
          this.dashboardlength = 'col-sm-12';
          console.log("Dashboard value is",this.isdashboard);
          // window.location.href = "Posts?Category=" + sel;
        }
        else
        {
          this.isdashboard = false;
          this.dashboardlength = 'col-sm-9';
          console.log("Dashboard value is",this.isdashboard);
        }
        this.router.navigate(route, { replace: replace });
        this.onNavigate();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }

      createBrandedVideo() {
        this.navigateLink('#/user/videos');
        window.open(window.site_url+"#/capture/brand/"+this.captureKey, "_blank");

        // href.bind="'#/capture/brand/' + captureKey"

      }
}
